import { render } from "./drawingCanvas.vue?vue&type=template&id=148e45a5"
import script from "./drawingCanvas.vue?vue&type=script&lang=js"
export * from "./drawingCanvas.vue?vue&type=script&lang=js"

import "./drawingCanvas.vue?vue&type=style&index=0&id=148e45a5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__